import {useMedia} from './useMedia';

const MOBILE_QUERIES = ['(max-width: 860px)'];
const CONDENSED_NEWS_QUERIES = ['(max-width: 1140px)'];
const MATCHED_VALUES = [true];

export const useMobile = () => {
  const isMobile = useMedia<boolean>(MOBILE_QUERIES, MATCHED_VALUES, false);
  return isMobile;
};

export const useCondensedNews = () => {
  return useMedia<boolean>(CONDENSED_NEWS_QUERIES, MATCHED_VALUES, false);
};
